// extracted by mini-css-extract-plugin
export default {"container":"Components_container__DpVP9","card":"Components_card__3WyRH"};